// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const Plus = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
            <polygon
                fill="currentColor"
                points="20.577 .577 20.577 0 19.423 0 19.423 .577 19.423 4.423 15.577 4.423 15 4.423 15 5.577 15.577 5.577 19.423 5.577 19.423 9.423 19.423 10 20.577 10 20.577 9.423 20.577 5.577 24.423 5.577 25 5.577 25 4.423 24.423 4.423 20.577 4.423"
                transform="translate(-15)"
            />
        </svg>
    );
};

export default React.memo(Plus);
